export enum NewsLetterStep {
  STEP_REGISTER = 0,
  STEP_ADDITIONAL_INFO = 1,
  STEP_THANKYOU = 2
}
